import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClassModel } from './class.model';
import { AbstractService } from '../services/abstract.service';

@Injectable({
    providedIn: 'root'
})
export class ClassService extends AbstractService<ClassModel> {
    constructor(http: HttpClient) {
        super(http, '/classes', ClassModel);
    }
}
